export default __webpack_public_path__ + "d601b53ecf670dd37f5caada20ae20cf.woff2";